import { GetAgentNotice, SaveAgentNotice,DelNotice} from '@/api/notice'
export default {
  state: {

  },
  actions: {
    GetAgentNotice({ commit }, payload) {
      return new Promise(resolve => {
        GetAgentNotice(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveAgentNotice({ commit }, payload) {
      return new Promise(resolve => {
        SaveAgentNotice(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    DelNotice({ commit }, payload) {
      return new Promise(resolve => {
        DelNotice(payload).then(res => {
          resolve(res.data)
        })
      })
    },
  },
  getters: {

  },
  mutations: {

  }
}
